import { createRouter, createWebHistory } from 'vue-router';
import home from '../views/home.vue';
import academiccandidatelist from '../views/academic staff/academiccandidatelist.vue';
import register from '../views/register.vue';
import login from '../views/login.vue';
import candidate from '../views/academic staff/candidate.vue';
import result from '../views/academic staff/result.vue'

import page404 from '../views/404.vue';

import sectionA from '../views/academic staff/sectiona.vue';
import sectionB from '../views/academic staff/sectionb.vue';
import sectionC from '../views/academic staff/sectionc.vue';

import section1 from '../views/nonacademic staff/section1.vue';
import section2 from '../views/nonacademic staff/section2.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: home,
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  },
  
  {
    path: '/academiccandidatelist/:faculty',
    name: 'academiccandidatelist',
    component: academiccandidatelist
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/register',
    name: 'register',
    component: register
  },
  {
    path: '/candidate/:id',
    name: 'candidate',
    component: candidate
  },
  {
    path: '/result/:id',
    name: 'result',
    component: result
  },
  {
    path: '/sectiona',
    name: 'sectionA',
    component: sectionA
  },
  {
    path: '/sectionb',
    name: 'sectionB',
    component: sectionB
  },
  {
    path: '/sectionc',
    name: 'sectionC',
    component: sectionC
  },
  {
    path: '/:catchAll(.*)',
    name: 'page404',
    component: page404
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
